<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-skeleton-loader
          :loading="printerLoading"
          :types="skeleton"
          type="article"
          elevation="1"
          height="300"
        >
          <ValidationObserver ref="printerForm" v-slot="{ invalid, passes }">
            <v-form
              rel="printerForm"
              @submit.prevent="passes(savePrinter)"
              autocomplete="off">
              <v-card class="elevation-2">
                <v-card-title class="px-9 pt-7">
                  Informace
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="6" md="3" sm="4" align-self="center">
                      <div class="printer-label px-9">
                        Název
                      </div>
                    </v-col>
                    <v-col cols="6" sm="5" align-self="center">
                      <div class="printer-value">
                        {{ printer.name }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="3" sm="4" align-self="center">
                      <div class="printer-label px-9">
                        Sériové číslo
                      </div>
                    </v-col>
                    <v-col cols="6" sm="5" align-self="center">
                      <div class="printer-value">
                        {{ printer.serialNumber }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="3" sm="4" align-self="center">
                      <div class="printer-label px-9">
                        Typ
                      </div>
                    </v-col>
                    <v-col cols="6" sm="5" align-self="center">
                      <div class="printer-value">
                        <PrinterType :type="printer.type"/>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="3" sm="4" align-self="center">
                      <div class="printer-label px-9">
                        Barevná
                      </div>
                    </v-col>
                    <v-col cols="6" sm="5" align-self="center">
                      <div class="printer-value">
                        {{ printer.color ? "ANO" : "NE" }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="3" sm="4" align-self="center">
                      <div class="printer-label px-9">
                        Stav
                      </div>
                    </v-col>
                    <v-col cols="6" sm="5" align-self="center">
                      <div class="printer-value">
                        {{ printer.status }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="3" sm="4" align-self="center">
                      <div class="printer-label px-9">
                        Stav zařízení
                      </div>
                    </v-col>
                    <v-col cols="6" sm="5" align-self="center">
                      <div class="printer-value">
                        {{ printer.statusDevice }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="3" sm="4" align-self="center">
                      <div class="printer-label px-9">
                        Chyba
                      </div>
                    </v-col>
                    <v-col cols="6" sm="5" align-self="center">
                      <div class="printer-value">
                        {{ printer.errorState }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="3" sm="4" align-self="center">
                      <div class="printer-label px-9">
                        Zpráva, upozornění
                      </div>
                    </v-col>
                    <v-col cols="6" sm="5" align-self="center">
                      <div class="printer-value">
                        {{ printer.alert }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="3" sm="4" align-self="center">
                      <div class="printer-label px-9">
                        Vytvořeno
                      </div>
                    </v-col>
                    <v-col cols="6" sm="5" align-self="center">
                      <div class="printer-value">
                        {{ $dayjs(printer.createdAt).format('D.M.YYYY H:mm') }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="3" sm="4" align-self="center">
                      <div class="printer-label px-9">
                        Upraveno
                      </div>
                    </v-col>
                    <v-col cols="6" sm="5" align-self="center">
                      <div class="printer-value">
                        {{ $dayjs(printer.updatedAt).format('D.M.YYYY H:mm') }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-card-title class="pt-7">
                    Zákazník a kredity
                  </v-card-title>
                  <v-row>
                    <v-col cols="6" md="3" sm="4" align-self="center">
                      <div class="printer-label px-9">
                        Název
                      </div>
                    </v-col>
                    <v-col cols="6" sm="5" align-self="center">
                      <div class="printer-value">
                        {{ printer.customer }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-if="printer.creditSystemLock">
                    <v-col cols="6" md="3" sm="4" align-self="center">
                      <div class="printer-label px-9">
                        Kredity
                      </div>
                    </v-col>
                    <v-col cols="6" sm="5" align-self="center">
                      <div class="printer-value">
                        {{ printer.credit ? printer.credit : '-' }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="3" sm="4" align-self="center">
                      <div class="printer-label px-9">
                        Zamykání při nízkém kreditu
                      </div>
                    </v-col>
                    <v-col cols="6" sm="5" align-self="center">
                      <div class="printer-value">
                        <v-checkbox
                          v-model="printer.creditSystemLock"
                          color="primary"
                          hide-details
                          label=""
                          class="ma-0 pa-0"
                          disabled
                        />
                      </div>
                    </v-col>
                  </v-row>
                  <v-card-title class="pt-7">
                    Přístupy
                  </v-card-title>
                  <v-row>
                    <v-col class="pt-5" cols="6" md="3" sm="4">
                      <div class="printer-label px-9">
                        Zákaznický kód
                      </div>
                    </v-col>
                    <v-col cols="6" sm="4">
                      <div class="mr-2">
                        <VTextFieldWithValidation
                          v-model="printer.code"
                          rules="customerCountLength"
                          outlined
                          dense
                        />
                        <a v-if="printer.code" :href="codeUrl" target="_blank">
                          {{ codeUrl }}
                        </a>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="pt-0 pr-6 pb-6 text-right">
                  <v-spacer></v-spacer>
                  <v-btn
                    type="submit"
                    height="40px"
                    min-width="130px"
                    color="primary"
                    depressed
                    :loading="printerSaveLoading"
                  >
                    Uložit
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </ValidationObserver>
        </v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row v-if="printer.tonerStatus.values.length">
      <v-col cols="12">
        <v-skeleton-loader
          :loading="printerLoading"
          :types="skeleton"
          type="article"
          elevation="1"
          height="300"
        >
          <v-card class="elevation-2">
            <v-card-title class="px-9 pt-7">
              Stav tonerů
            </v-card-title>
            <v-card-text>
              <ExportData :type="'TONER'"/>
            </v-card-text>
            <ValidationObserver ref="tonerStatusForm" v-slot="{ invalid, passes }">
              <v-form
                rel="tonerStatusForm"
                @submit.prevent="passes(saveTonerStatus)"
                autocomplete="off">
                <v-card-text>
                  <v-simple-table>
                    <thead>
                    <tr>
                      <th class="text-left">Toner</th>
                      <th class="text-left">Hodnota</th>
                      <th class="text-left">Počet dodaných kusů</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      v-for="item in printer.tonerStatus.values"
                      :key="item.type"
                      style="height: 56px"
                    >
                      <td>{{ item.type }}</td>
                      <td>{{ item.value }}</td>
                      <td class="pt-1 pb-1 pr-6">
                        <VTextFieldWithValidation
                          v-if="item.supplyUpdatable"
                          v-model="item.supply.amountSent"
                          type="number"
                          hide-messages
                          rules="minTonerCount"
                          suffix="ks"
                          outlined
                          dense
                          class="toner"
                        />
                      </td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
                <v-card-text v-if="invalid" class="pt-0 pb-0 error--text">
                  Počet kusů musí být celé číslo větší nebo rovno 0
                </v-card-text>
                <v-card-actions class="pt-0 pr-6 pb-6 text-right">
                  <v-spacer></v-spacer>
                  <v-btn
                    type="submit"
                    height="40px"
                    min-width="130px"
                    color="primary"
                    depressed
                    :loading="printerTonerStatusLoading"
                  >
                    Uložit
                  </v-btn>
                </v-card-actions>
              </v-form>
            </ValidationObserver>
          </v-card>
        </v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row v-if="counterValues.length">
      <v-col cols="12">
        <v-skeleton-loader
          :loading="printerLoading"
          :types="skeleton"
          type="article"
          elevation="1"
          height="300"
        >
          <v-card class="elevation-2">
            <v-card-title class="px-9 pt-7">
              {{ printer.type === 'GENERIC' ? 'Počítadla tiskárny' : 'Stav počítadel' }}
            </v-card-title>
            <v-card-text>
              <ExportData :type="'COUNTER'"/>
            </v-card-text>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-left">Kód</th>
                    <th class="text-left">Hodnota</th>
                    <th v-if="printer.type === 'GENERIC'" class="text-right">Akce</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    v-for="item in counterValues"
                    :key="item.code"
                    style="height: 56px"
                  >
                    <td>{{ item.code }} {{ item.description ? ' - ' +  item.description : '' }}</td>
                    <td>{{ item.value }}</td>
                    <td v-if="printer.type === 'GENERIC'" class="text-right">
                      <v-btn
                        icon
                        color="blue-grey"
                        title="Skrýt počítadlo"
                        :aria-label="`Skrýt počítadlo ${item.code}`"
                        :loading="printerCounterLoading === item.code"
                        :disabled="!!printerCounterLoading"
                        @click="confirmHidePrinterCounter(item)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
            <v-card-actions class="pt-0 pr-6 pb-6 text-right">
            </v-card-actions>
          </v-card>
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { downloadFile } from '@/components/mixins/downloadFile';
import ExportData from '@/components/ExportData.vue';
import PrinterType from '@/components/PrinterType.vue';

export default {
  name: 'PrinterDetail',
  components: { PrinterType, ExportData },
  mixins: [downloadFile],
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      host: window.location.host,
      protocol: window.location.protocol,
      printerLoading: false,
      printerSaveLoading: false,
      printerTonerStatusLoading: false,
      printerCounters: [],
      printerCounterLoading: null,
      printer: {
        serialNumber: this.$route.params.serialNumber,
        name: null,
        color: null,
        customer: null,
        status: null,
        statusDevice: null,
        errorState: null,
        createdAt: null,
        updatedAt: null,
        tonerStatus: {
          timestamp: null,
          values: [],
        },
        counterStatus: {
          timestamp: null,
          values: [],
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['code'],
          sortDesc: [false],
        },
      },
      cancel: null,
    };
  },
  computed: {
    counterValues() {
      const values = this.printer.counterStatus ? this.printer.counterStatus.values : [];
      if (this.printer.type !== 'GENERIC') {
        return values;
      }

      const valuesByCode = new Map(values.map((item) => [item.code, item]));
      return this.printerCounters.filter((counter) => !counter.hidden).map((counter) => {
        const status = valuesByCode.get(counter.code);
        return {
          code: counter.code,
          description: counter.description,
          value: status ? status.value : '-',
        };
      });
    },
    codeUrl() {
      return `${this.protocol}//${this.host}/customer/${this.printer.code}`;
    },
  },
  methods: {
    ...mapActions({
      updatePrinter: 'printers/updatePrinter',
      getPrinter: 'printers/getPrinter',
      updatePrinterToner: 'printers/updatePrinterToner',
      getPrinterCounters: 'printers/getPrinterCounters',
      updatePrinterCounter: 'printers/updatePrinterCounter',
    }),
    loadPrinterCounters() {
      return this.getPrinterCounters(this.$route.params.serialNumber).then((response) => {
        this.printerCounters = response.data;
      });
    },
    confirmHidePrinterCounter(counter) {
      return this.$confirm('<p class="text--primary">Počítadlo bude v seznamu znovu zobrazeno po aktualizaci jeho hodnoty tiskárnou.</p>', {
        title: `Skrýt počítadlo ${counter.code} v seznamu?`,
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'primary',
        width: 600,
      }).then((result) => {
        if (result) {
          return this.savePrinterCounter(counter);
        }
        return null;
      });
    },
    savePrinterCounter(counter) {
      this.printerCounterLoading = counter.code;
      return this.updatePrinterCounter({
        serialNumber: this.$route.params.serialNumber,
        code: counter.code,
        hidden: true,
      })
        .then(() => {
          this.printerCounters = this.printerCounters.filter((item) => item.code !== counter.code);
          this.$notify.success({
            title: 'Uloženo',
            message: 'Počítadlo bylo skryto',
            type: 'success',
            position: 'top-right',
          });
          return this.loadPrinter();
        })
        .catch(() => {
          this.$notify.error({
            title: 'Chyba',
            message: 'Počítadlo se nepodařilo skrýt',
            type: 'error',
            position: 'top-right',
          });
        })
        .finally(() => {
          this.printerCounterLoading = null;
        });
    },
    loadPrinter() {
      this.printerLoading = true;
      return this.getPrinter(this.$route.params.serialNumber).then((response) => {
        this.printer = response.data;
        this.fixTonerSupplyData();
        if (this.printer.type === 'GENERIC') {
          return this.loadPrinterCounters();
        }
        return null;
      }).catch((error) => {
        if (error.response && error.response.status === 404) {
          this.$router.push({
            path: '/404',
          });
        }
      }).finally(() => {
        this.printerLoading = false;
      });
    },
    savePrinter() {
      this.printerSaveLoading = true;
      this.updatePrinter(this.printer)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$notify.success({
              title: 'Uloženo',
              message: 'Tiskárna byla uložena',
              type: 'success',
              position: 'top-right',
            });
          }
        })
        .finally(() => {
          this.printerSaveLoading = false;
        });
    },
    saveTonerStatus() {
      this.printerTonerStatusLoading = true;
      this.updatePrinterToner({
        serialNumber: this.$route.params.serialNumber,
        data: this.transformTonerSupplyData(),
      })
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$notify.success({
              title: 'Uloženo',
              message: 'Stav tonerů byl uložen',
              type: 'success',
              position: 'top-right',
            });
          }
        })
        .finally(() => {
          this.printerTonerStatusLoading = false;
        });
    },
    transformTonerSupplyData() {
      const toners = [];
      this.printer.tonerStatus.values.forEach((e) => {
        toners.push(
          {
            type: e.type,
            amountSent: e.supply ? e.supply.amountSent : 0,
          },
        );
      });
      return toners;
    },
    fixTonerSupplyData() {
      const values = [];
      this.printer.tonerStatus.values.forEach((e) => {
        e.supply.amountSent = e.supply.amountSent.toString();
        values.push(e);
      });
      this.printer.tonerStatus.values = values;
    },
    async copyUrl() {
      try {
        await navigator.clipboard.writeText(this.codeUrl);
      } catch (e) {
        console.log(e);
      }
    },
  },
  watch: {
    '$route.params.id': {
      handler() {
        this.loadPrinter();
      },
    },
  },
  created() {
    this.loadPrinter();
  },
};
</script>

<style scoped>
.toner ::v-deep input,
.toner ::v-deep input {
  padding: 0;
  text-align: right;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  text-align: right;
  -webkit-appearance: none;
  margin: 0;
  padding: 0;
}

::v-deep .v-text-field__suffix {
  color: rgba(0, 0, 0, 0.38);
}
</style>
